// Shared formatting for the ORB-384 engagement surfaces.

// A rate is null when there's no denominator yet (delivered === 0) — render an em dash, never a
// misleading 0%. A measured zero (delivered > 0, nobody engaged) is a real 0 and shows as "0%".
export function formatRate(value: number | null | undefined): string {
  return value == null ? '—' : `${value}%`
}

// A short relative time ("2d ago", "3h ago") for engagement timestamps; falls back to a locale date.
export function relativeFromNow(iso: string | null | undefined): string {
  if (!iso) return '—'
  const then = new Date(iso)
  const ms = then.getTime()
  if (Number.isNaN(ms)) return '—'
  const diffSec = Math.round((Date.now() - ms) / 1000)
  if (diffSec < 60) return 'just now'
  const diffMin = Math.round(diffSec / 60)
  if (diffMin < 60) return `${diffMin}m ago`
  const diffHr = Math.round(diffMin / 60)
  if (diffHr < 24) return `${diffHr}h ago`
  const diffDay = Math.round(diffHr / 24)
  if (diffDay < 30) return `${diffDay}d ago`
  return then.toLocaleDateString()
}

export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return '—'
  const d = new Date(iso)
  return Number.isNaN(d.getTime()) ? String(iso) : d.toLocaleString()
}

/**
 * A count that may not be on the wire yet. The dashboard and the API deploy separately, so between the
 * two merges a field the UI expects can simply be absent — and a render throw there does not degrade
 * one number, it blanks the whole page through the app's single ErrorBoundary.
 *
 * An em dash rather than 0: absent is not the same as measured-zero, and this component's whole point
 * is not printing numbers it cannot stand behind.
 */
export function formatCount(value: number | null | undefined): string {
  return value == null ? '—' : value.toLocaleString()
}
